/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramTitleBlockMngDtoContent } from './programTitleBlockMngDtoContent';


export interface ProgramTitleBlockMngDto { 
    /**
     * The type of the title block. Identifies the structure of \"content\" property.
     */
    titleBlockType: ProgramTitleBlockMngDto.TitleBlockTypeEnum;
    content: ProgramTitleBlockMngDtoContent;
}
export namespace ProgramTitleBlockMngDto {
    export type TitleBlockTypeEnum = 'text' | 'progress';
    export const TitleBlockTypeEnum = {
        Text: 'text' as TitleBlockTypeEnum,
        Progress: 'progress' as TitleBlockTypeEnum
    };
}


